import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import './index.css';
import HomePage from './HomePages/HomePage'
import HomePageRoutes from './HomePages/HomePageRoutes'
import Countdown from './Countdown/Countdown'
import PageNotFound from './PageNotFound'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/routes" element={<HomePageRoutes />} />
      <Route path="/countdown" element={<Countdown />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </BrowserRouter>
);
